module.exports = __webpack_public_path__ + "usa-flag.b72777a1.png";


//////////////////
// WEBPACK FOOTER
// ./demo/src/static/usa-flag.png
// module id = T/1d
// module chunks = 1